import { useState } from "react";
import { useClerk } from "@clerk/react";
import { Lock } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api, errMsg } from "@/lib/api";

export default function LockScreen({ onUnlocked, me }) {
  const { signOut } = useClerk();
  const [pin, setPin] = useState("");
  const [busy, setBusy] = useState(false);
  const unlock = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/me/unlock", { pin });
      onUnlocked();
    } catch (err) {
      if (err.response?.status === 429) { toast.error(errMsg(err)); signOut(); }
      else toast.error(errMsg(err));
      setPin("");
    } finally { setBusy(false); }
  };
  return (
    <div className="min-h-screen bg-slate-900 flex items-center justify-center p-6" data-testid="lock-screen">
      <form onSubmit={unlock} className="w-full max-w-sm bg-white rounded-2xl p-8 text-center fade-in">
        <img src="/ace-mark.png" alt="ACE eSIGN" className="h-12 w-auto mx-auto" data-testid="lock-brand-mark" />
        <h1 className="text-2xl font-bold mt-4 flex items-center justify-center gap-2"><Lock className="w-5 h-5" />Staff mode locked</h1>
        <p className="text-sm text-slate-600 mt-2">Patient information is hidden. {me.name}, enter your staff PIN to continue.</p>
        <Input autoFocus type="password" inputMode="numeric" aria-label="Staff PIN" className="mt-6 h-14 text-center text-2xl tracking-[0.5em]"
          value={pin} onChange={(e) => setPin(e.target.value)} data-testid="unlock-pin-input" />
        <Button type="submit" disabled={busy || !pin} className="w-full h-12 mt-4 bg-slate-900" data-testid="unlock-submit-btn">Unlock</Button>
        <button type="button" onClick={() => signOut()} className="mt-4 text-sm text-slate-500 underline" data-testid="lock-signout-btn">Sign out instead</button>
      </form>
    </div>
  );
}
